module.exports = __webpack_public_path__ + "static/media/rideforlife-web25.05b22941.jpg";